
// Libraries
var React = require('react');
var $ = require('jquery');

// Styles
require('./InPageTabsBar.scss');

class InPageTabsBar extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			...this.props,
			moreLinks: null,
			isDropdownOpen: false
		};
	}

	componentWillMount() {

		let mobileLinks = this.state.tabs;

		if (this.state.tabs.length > 6) {
			let moreLinks = this.state.tabs.slice(5, this.state.tabs.length);
			let links = this.state.tabs.slice(0, 5);

			this.setState({
				...this.state,
				links: links,
				moreLinks: moreLinks,
				mobileLinks: mobileLinks
			});
		} else {
			let links = this.state.tabs.slice();
			this.setState({
				...this.state,
				links: links,
				mobileLinks: mobileLinks
			});
		}
	};

	// Set the width for mobile, to enable horizontal scrolling.
	// If element selected not in the viewport, scroll to it.
	resizeMobileBar() {
		// Resize the bar.
		let mobileWidth = 0;
		let viewportWidth = $(window).width();

		$(this.mobileBar).children().each(function(i, item){
			mobileWidth += $(item).width();
		});

		$(this.mobileBar).width(mobileWidth < viewportWidth ? viewportWidth : mobileWidth);

		// Scroll to element.
		$(this.moduleElem).scrollLeft(
			$(this.moduleElem).find(".InPageTabsBar--mobile .in-tab-selected").offset().left
			- $(this.moduleElem).width() / 2
			+ $(this.moduleElem).find(".InPageTabsBar--mobile .in-tab-selected").outerWidth() / 2
		);
	}

	componentDidMount() {
		if (typeof window !== "undefined") {
			this.resizeMobileBar();
		}

		$( window ).resize(() => {
			this.resizeMobileBar();
		});
	};

	asyncKeydownHandler = (event, index) => {
		if (event.key === 'Enter') {
			this.props.handleClick(event, index);
		}
	};

	handleEscClose = (event) => {
		if (event.key === 'Escape') {
			this.toggleMenu();
		}
	};

	toggleMenu = () => {
		this.setState({
			isDropdownOpen: !this.state.isDropdownOpen
		}, () => {
			this.moreButton.focus()
		});
	};

	render() {
		return (
			<nav className="InPageTabsBar" ref={(moduleElem) => { this.moduleElem = moduleElem; }} aira-label="Page Tabs">

				{/* Mobile Nav with scrollable horizontal items */}
				<div className="InPageTabsBar--mobile" ref={(mobileBar) => { this.mobileBar = mobileBar; }}>
					{this.state.mobileLinks.length > 0 && this.state.mobileLinks.map((item, index) => {
						return(
							<div className={item.isSelected ? "InPageTabsBar__item in-tab-selected" : "InPageTabsBar__item"} key={index}>
								<a onClick={(event) => this.props.handleClick(event, index)} href={item.url} target={item.newWindow ? "_blank" : "_self"} rel={item.newWindow ? "noopener noreferrer" : undefined} className={"InPageTabsBar__item__sub" + (item.hasIndicator ? " InPageTabsBar__item__sub--indicator" : "")}>{item.caption}</a>
							</div>
						)
					})}
				</div>

				{/* Desktop Nav with horizontal items and "show more" */}
				<div className={this.state.tabs.length > 5 ? "InPageTabsBar--desktop" : "InPageTabsBar--desktop short"} role="list">
					{this.state.links && this.state.links.length > 0 && this.state.links.map((item, index) => {
						return(
							<div className={item.isSelected ? "InPageTabsBar__item in-tab-selected" : "InPageTabsBar__item"} key={index} role="listitem">
								<a onClick={(event) => this.props.handleClick(event, index)} onKeyDown={(event) => this.asyncKeydownHandler(event, index)} href={item.url} target={item.newWindow ? "_blank" : "_self"} rel={item.newWindow ? "noopener noreferrer" : undefined} className={"InPageTabsBar__item__sub" + (item.hasIndicator ? " InPageTabsBar__item__sub--indicator" : "")}>{item.caption}</a>
							</div>
						)
					})}

					{this.state.moreLinks &&
						<div onClick={this.toggleMenu} className={"InPageTabsBar__item InPageTabsBar__handle" + (this.state.isDropdownOpen ? " is-open" : "")} key="DesktopHandle" role="listitem" aria-haspopup="true">


							<button className={"InPageTabsBar__item__sub" + (this.state.moreLinks.find(x => x.isSelected) ? " in-tab-selected" : "")} aria-expanded={this.state.isDropdownOpen} ref={(button) => this.moreButton = button}>More</button>

							<div className={"InPageTabsBar__dropdown" + (this.state.isDropdownOpen ? " is-open" : "")} role="list" onKeyDown={this.handleEscClose}>
								{this.state.moreLinks.map((item, index) => {
									return(
										<div className={item.isSelected ? "InPageTabsBar__item in-tab-selected" : "InPageTabsBar__item"} key={index} role="listitem">
											<a onClick={(event) => this.props.handleClick(event, this.state.tabs.indexOf(this.state.moreLinks[index]))} onKeyDown={(event) => this.asyncKeydownHandler(event, this.state.tabs.indexOf(this.state.moreLinks[index]))} href={item.url} target={item.newWindow ? "_blank" : "_self"} rel={item.newWindow ? "noopener noreferrer" : undefined} tabIndex="0" className={"InPageTabsBar__item__sub" + (item.hasIndicator ? " InPageTabsBar__item__sub--indicator" : "")}>{item.caption}</a>
										</div>
									)
								})}
							</div>
						</div>
					}
				</div>
			</nav>
		)
	}
}

module.exports = InPageTabsBar;



// WEBPACK FOOTER //
// ./src/components/Navigation/InPageTabs/InPageTabsBar.js